var queryString = require('query-string');
var query = queryString.parse(location.search);

var isHtfBuild = query.htfServer != null;
if( isHtfBuild ) {
    Module.preRun = Module.preRun || [];
    Module['preRun'].push(function() {
        var glCreateContext = GL.createContext
        GL.createContext = function (canvas, webGLContextAttributes) {
            webGLContextAttributes.preserveDrawingBuffer = true;
            return glCreateContext(canvas, webGLContextAttributes);
        }
    })
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/huuugetestframework/src/TestManager.js
// module id = 49
// module chunks = 0